import React from 'react';
import '../css/App.css';
import TheRestInMotionSite from "./theRestInMotionSite";

function App() {
  return (
    <TheRestInMotionSite />
  );
}

export default App;
